import {
  AccountsReceivableState,
  AccountsReceivableAction,
  AccountsReceivableActionType,
  accountsReceivableInitialState
} from '../../../interfaceTypes/accountsReceivable'

export const accountsReceivableReducer = (
  state: AccountsReceivableState,
  action: AccountsReceivableAction
): AccountsReceivableState => {
  switch (action.type) {
    case AccountsReceivableActionType.SET_AR_ENTRIES:
      return {
        ...state,
        arEntries: action.arEntries
      }

    case AccountsReceivableActionType.SET_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...action.filters }
      }

    case AccountsReceivableActionType.SET_AR_ENTRIES_SUMMARY:
      return {
        ...state,
        arEntriesSummary: action.arEntriesSummary
      }

    case AccountsReceivableActionType.SET_LOADING:
      return {
        ...state,
        loading: action.loading
      }

    case AccountsReceivableActionType.RESET_FILTERS:
      return {
        ...state,
        filters: {}
      }

    default:
      return state
  }
}

export { accountsReceivableInitialState }
